module.exports = __webpack_public_path__ + "img/iconsCart.ec6d7f66.png";